/* Livera Skin Shield — Male PDP JS */

(function () {
  'use strict';

  // ---- Variant data (index-based, 0=1+1, 1=1.5+1.5, 2=2+2, 3=3+3) ----
  // Upsell map: selected index → upsell index
  const UPSELL_MAP = {
    0: { targetIndex: 1, title: 'Upgrade naar 3 maanden', subtitle: 'Krijg 30 dagen gratis — voor maar €10 meer', saving: 'Je bespaart €10 t.o.v. losse aankoop' },
    1: { targetIndex: 2, title: 'Upgrade naar 4 maanden', subtitle: 'Krijg 30 dagen gratis — voor maar €15 meer', saving: 'Je bespaart €15 t.o.v. losse aankoop' },
    2: { targetIndex: 3, title: 'Upgrade naar 6 maanden', subtitle: 'Krijg 60 dagen gratis — voor maar €30 meer', saving: 'Je bespaart €30 t.o.v. losse aankoop' }
    // index 3 (3+3) = no upsell, direct checkout
  };

  // ---- Variant selection ----
  const variantCards = document.querySelectorAll('.ssm-variant-card');
  let selectedVariantId = null;
  let selectedVariantIndex = 2; // default: 2+2 (index 2)

  function selectVariant(index) {
    variantCards.forEach((c, i) => {
      c.classList.toggle('selected', i === index);
    });
    const card = variantCards[index];
    if (card) {
      selectedVariantId = card.dataset.variantId;
      selectedVariantIndex = index;
    }
  }

  variantCards.forEach((card, index) => {
    card.addEventListener('click', () => selectVariant(index));
  });

  // Pre-select 2+2 (index 2), fallback to first if fewer variants
  const defaultIndex = variantCards.length > 2 ? 2 : 0;
  selectVariant(defaultIndex);

  // ---- Upsell popup ----
  const overlay = document.getElementById('ssm-upsell-overlay');
  const upsellTitle = document.getElementById('ssm-upsell-title');
  const upsellSubtitle = document.getElementById('ssm-upsell-subtitle');
  const upsellOfferName = document.getElementById('ssm-upsell-offer-name');
  const upsellOfferPrice = document.getElementById('ssm-upsell-offer-price');
  const upsellOfferSaving = document.getElementById('ssm-upsell-offer-saving');
  const upsellAccept = document.getElementById('ssm-upsell-accept');
  const upsellDecline = document.getElementById('ssm-upsell-decline');
  const upsellClose = document.getElementById('ssm-upsell-close');

  let pendingOriginalId = null;
  let pendingUpsellId = null;

  function showUpsellOrCheckout(originalVariantId, originalIndex) {
    const upsell = UPSELL_MAP[originalIndex];
    if (!upsell || !overlay) {
      // Highest tier or no popup defined — go straight to checkout
      addToCartAndRedirect(originalVariantId);
      return;
    }

    const upsellCard = variantCards[upsell.targetIndex];
    if (!upsellCard) {
      addToCartAndRedirect(originalVariantId);
      return;
    }

    pendingOriginalId = originalVariantId;
    pendingUpsellId = upsellCard.dataset.variantId;

    // Populate modal
    if (upsellTitle) upsellTitle.textContent = upsell.title;
    if (upsellSubtitle) upsellSubtitle.textContent = upsell.subtitle;
    if (upsellOfferName) upsellOfferName.textContent = upsellCard.querySelector('.ssm-variant-card__name')?.textContent || '';
    if (upsellOfferPrice) upsellOfferPrice.textContent = upsellCard.querySelector('.ssm-variant-card__price')?.textContent || '';
    if (upsellOfferSaving) upsellOfferSaving.textContent = upsell.saving;

    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeUpsell() {
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
    pendingOriginalId = null;
    pendingUpsellId = null;
  }

  if (upsellAccept) {
    upsellAccept.addEventListener('click', () => {
      closeUpsell();
      addToCartAndRedirect(pendingUpsellId || selectedVariantId);
    });
  }

  if (upsellDecline) {
    upsellDecline.addEventListener('click', () => {
      const id = pendingOriginalId;
      closeUpsell();
      addToCartAndRedirect(id);
    });
  }

  if (upsellClose) {
    upsellClose.addEventListener('click', () => {
      const id = pendingOriginalId;
      closeUpsell();
      addToCartAndRedirect(id);
    });
  }

  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        const id = pendingOriginalId;
        closeUpsell();
        addToCartAndRedirect(id);
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('active')) {
      const id = pendingOriginalId;
      closeUpsell();
      addToCartAndRedirect(id);
    }
  });

  // ---- ATC core ----
  function addToCartAndRedirect(variantId) {
    if (!variantId) return;
    const btns = document.querySelectorAll('.ssm-atc-btn, .ssm-mid-atc__btn, .ssm-sticky-atc__btn');
    btns.forEach(b => { b.disabled = true; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(r => r.json())
      .then(data => {
        if (data.id) {
          window.location.href = '/checkout';
        } else {
          btns.forEach(b => { b.disabled = false; });
          alert('Er ging iets mis. Probeer het opnieuw.');
        }
      })
      .catch(() => {
        btns.forEach(b => { b.disabled = false; });
      });
  }

  function handleAtcClick() {
    showUpsellOrCheckout(selectedVariantId, selectedVariantIndex);
  }

  const atcBtn = document.querySelector('.ssm-atc-btn');
  if (atcBtn) atcBtn.addEventListener('click', handleAtcClick);

  const midAtcBtn = document.querySelector('.ssm-mid-atc__btn');
  if (midAtcBtn) midAtcBtn.addEventListener('click', handleAtcClick);

  const stickyBtn = document.querySelector('.ssm-sticky-atc__btn');
  if (stickyBtn) stickyBtn.addEventListener('click', handleAtcClick);

  // ---- Hero gallery ----
  const mainImg = document.querySelector('.ssm-hero__main-img');
  const thumbs = document.querySelectorAll('.ssm-hero__thumb');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImg) mainImg.src = thumb.dataset.full || thumb.src;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
  if (thumbs.length > 0) thumbs[0].classList.add('active');

  // ---- Ingredient tabs ----
  const tabBtns = document.querySelectorAll('.ssm-tab-btn');
  const tabContents = document.querySelectorAll('.ssm-tab-content');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      tabBtns.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      const target = document.querySelector('[data-tab="' + btn.dataset.tab + '"]');
      if (target) target.classList.add('active');
    });
  });
  if (tabBtns.length > 0) tabBtns[0].click();

  // ---- FAQ accordion ----
  const faqItems = document.querySelectorAll('.ssm-faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.ssm-faq-question');
    if (question) {
      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        faqItems.forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    }
  });

})();
